import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { upperCaseFirstLetter } from '../../../helpers/common'
import { COMPONENTS } from '../../../routers/constants'
import { CriteriaPreview } from './criteriaPreview'
import { CriteriaTable } from './criteriaTable'
import { Filter } from './filter'
import classes from './index.module.scss'
import { selectFilter, selectLoading, selectTotalRecords } from './store/slice'
import { getSavedCriterias } from './store/thunk'

export const SavedCriteria = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { keyword, from, to, page, pageSize, sortBy, sortDirection } =
    useSelector(selectFilter())
  const totalRecords = useSelector(selectTotalRecords)
  const isLoading = useSelector(selectLoading('criterias'))

  const isNoFilter = !keyword && !from && !to && page === 1 && pageSize > 0

  useEffect(() => {
    const params = { Page: page, PageSize: pageSize }
    if (keyword) params.Name = keyword
    if (from) params.FromDate = from
    if (to) params.ToDate = to
    if (sortBy && sortDirection) {
      params.Sort = upperCaseFirstLetter(sortBy)
      params.SortDirection = sortDirection
    }
    dispatch(getSavedCriterias(params))
  }, [keyword, from, to, page, pageSize, sortBy, sortDirection])

  const backToScreening = () => {
    navigate(COMPONENTS.screening.route)
  }

  return (
    <Element className={classes.savedCriteria}>
      <Element
        elementName="button"
        className={classes.backBtn}
        style={{ color: '#3A414B', borderColor: '#D5D5D5' }}
        onClick={backToScreening}
      >
        <Element className="dFlex alignItemsCenter" style={{ gap: 4 }}>
          <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
          <Element elementName="span">
            <Translate value="screening.BACK_TO_SCREENING" />
          </Element>
        </Element>
      </Element>

      <Element
        className={classes.screenName}
        style={{ fontSize: 20, color: '#191D25' }}
      >
        <Translate value="screening.ALL_SAVED_CRITERIA" />
      </Element>

      <Element className={classes.mainContent}>
        {!totalRecords && isNoFilter && !isLoading ? (
          <Element className="wh100" style={{ backgroundColor: '#F3F3F3' }}>
            <Element
              className="textCenter fw500 pt5 mt5"
              style={{ fontSize: 20, color: '#9C9C9C' }}
            >
              <Translate value="screening.NO_SAVED_CRITERIA" />
            </Element>
          </Element>
        ) : (
          <>
            <Filter />
            <Element className={classes.content}>
              <CriteriaTable />
              <CriteriaPreview />
            </Element>
          </>
        )}
      </Element>
    </Element>
  )
}
